import { render, staticRenderFns } from "./MainNavigationMenu.vue?vue&type=template&id=7aee2af2"
import script from "./MainNavigationMenu.vue?vue&type=script&lang=js"
export * from "./MainNavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationMenu.vue?vue&type=style&index=0&id=7aee2af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports